// Pure naming rules for cookies. No imports on purpose: the suffix is the one piece the shell
// and the three legacy SPAs must agree on byte for byte, so it is kept trivially copyable and
// testable without a DOM or a cookie library.

// Cookie NAMES carry the tenant and the env, because the cookie DOMAIN is not unique to a
// tenant. zing is the default app on the bare zinginnovation.com, so its cookie domain
// (.zinginnovation.com) is the parent of app.whitelabel…, app.hubhorizonte…, app.hubguaxupe…
// and of every dev/hmg host under them. Two tenants each writing a plain `_cred` therefore
// produce TWO cookies with the SAME name, both sent to the same host; the reader takes the
// first, which is the older one, so a stale session from another tenant silently shadows a
// fresh login and the API answers 400 on a company_id that belongs to nobody there.
export const buildCookieScope = (tenantDomain?: string, envName?: string): string => {
  const tenant = (tenantDomain != null && tenantDomain !== '') ? tenantDomain.toLowerCase() : 'unknown'
  const env = (envName != null && envName !== '') ? envName.toLowerCase() : 'unknown'
  return `${tenant}_${env}`
}

export const scopedCookieNameFor = (cookieName: string, scope: string): string => `${cookieName}__${scope}`

// Names written before the scoping existed. They are NOT read any more, but a stale one sits
// on a parent domain for up to a day and would still be sent to every tenant host, so they are
// cleared once at boot instead of being left to expire.
export const UNSCOPED_LEGACY_NAMES = [
  '_cred',
  '_credShared',
  '_perm',
  '_permCodes',
  '_usrData',
  '_userUpdatedAt',
  '_profImg',
  '_caixaRole',
  '_banner_update_late'
]

// A cookie can only be deleted at the domain it was set on, and the stale one may sit on a
// PARENT of this host (zing's `.zinginnovation.com` seen from app.whitelabel…), which the
// app's own cookie domain would never reach. Every parent with at least two labels is tried;
// a removal aimed at a domain that holds no such cookie is simply ignored by the browser.
export const parentDomains = (hostname: string): string[] => {
  const labels = hostname.split('.')
  const domains: string[] = []
  for (let i = 0; i <= labels.length - 2; i += 1) {
    domains.push(`.${labels.slice(i).join('.')}`)
  }
  return domains
}
